import { useSearchInitiativesQuery } from "@/services";
import { useQueryParams } from "use-query-params";
import * as GlobalS from "@/components/styled";
import { InitiativeTable } from "./components/InitiativeTable";
import { Button } from "antd";
import { useIntl } from "react-intl";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { routes } from "@/helpers";
import { PageWrapper } from "@/components";
import { Pager } from "@/sharedStyled";
import { INITIATIVE_DEFAULT_QUERY_PARAMS } from "./constants";

const PAGE_SIZE = 20;

export const InitiativeList = () => {
  const [queryParams, setQueryParams] = useQueryParams({
    ...INITIATIVE_DEFAULT_QUERY_PARAMS
  });

  const { data: response, isFetching } = useSearchInitiativesQuery({
    sortByLaunchDateDescending: queryParams.orderBy?.some((order: string | null) => order === "estimatedTargetLaunchDate desc"),
    status: queryParams.status?.length ? queryParams.status.join(",") : undefined,
    projectTypeIds: queryParams.projectTypeIds,
    productCategoryIds: queryParams.productCategoryIds,
    page: queryParams.page || 1,
    pageSize: PAGE_SIZE
  }, { refetchOnMountOrArgChange: true });

  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <PageWrapper pageTitle={intl.formatMessage({ id: "initiative.title" })}>
      <GlobalS.PageContentCard
        title={intl.formatMessage({ id: "initiative.title" })}
        extra={
          <Button
            data-test-id="initiative-create"
            type="primary"
            icon={<FontAwesomeIcon icon={faCirclePlus} />}
            onClick={() => navigate(routes.initiatives.new)}
          >
            {intl.formatMessage({ id: "initiative.createInitiative" })}
          </Button>
        }>
        <InitiativeTable
          data={response?.data}
          isFetching={isFetching}
        />
        <Pager
          defaultCurrent={queryParams.page || 1}
          current={queryParams.page || 1}
          pageSize={PAGE_SIZE}
          total={response?.totalCount}
          showSizeChanger={false}
          onChange={(page: number): void => setQueryParams({ page })}
          data-test-id="initiatives-table-pagination"
        />
      </GlobalS.PageContentCard>
    </PageWrapper>
  );
};